module.exports = __webpack_public_path__ + "media/04_【アプリ版】承認編.743a1f3b.mp4";